<template>
    <div>
        <v-app>
            <v-card>
                <v-card-text>
                    <v-text-field v-model="basicPropertyMap.name" label="类型名称*" :rules="[v => !!v || '类型名称不能为空']"></v-text-field>
                    <!-- :rules="[v => !!v || '模型编号不能为空']" -->
                    <v-text-field v-model="basicPropertyMap.model_number" label="模型编号*" ></v-text-field>
                    <v-text-field v-model="basicPropertyMap.model_name" label="模型名称"></v-text-field>
                    <div class="picture-container" style="padding-top: 25px; cursor: pointer; border: 0px">
                        <div class="picture">
                            <div v-if="basicPropertyMap.icon" class="pictureImg">
                                <img style="width: 200; height: 120px" :src="basicPropertyMap.icon" />
                                <input type="file" @change="upload" />
                            </div>
                            <div v-else>
                                <!-- <img :src="require('/public/img/image_placeholder.jpg')" @click="getImage" /> -->
                                <input type="file" @change="upload" />
                            </div>
                        </div>
                        <h6 class="description">请选择图片生成或更新缩略图</h6>
                    </div>
                    <v-switch v-model="basicPropertyMap.is_public" label="公开"></v-switch>
                    <v-text-field v-model="basicPropertyMap.symbol" label="符号"></v-text-field>
                    <v-text-field v-model="basicPropertyMap.specifications" label="规格型号"></v-text-field>
                    <v-text-field v-model="basicPropertyMap.manufacturer" label="生成厂商"></v-text-field>
                    <v-text-field v-model="basicPropertyMap.structure_desc" label="结构说明"></v-text-field>
                    <v-text-field v-model="basicPropertyMap.principle_desc" label="原理说明"></v-text-field>
                    <v-text-field v-model="basicPropertyMap.function_desc" label="功能说明"></v-text-field>
                </v-card-text>
            </v-card>
        </v-app>
    </div>
</template>
<script>
// import Swal from 'sweetalert2'
import { upload } from '@/api/user';
export default {
    name: 'BaseTab',
    inject: ['topNode'],
    data() {
        return {
            basicPropertyMap: {}
        }
    },
    methods: {
        init(form) {
            if (typeof form === 'object') {
                this.basicPropertyMap = form
            }
        },
        upload(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.createImage(files[0]);
        },
        createImage(file) {
            let reader = new FileReader();

            reader.onload = (e) => {
                // this.user.avatar = e.target.result;
            };
            reader.readAsDataURL(file);
            let type = file.type.split('/') && file.type.split('/')[1] ? file.type.split('/')[1] : '';
            if (!['jpeg', 'jpg', 'png'].includes(type)) {
                this.$message.warning('请选择正确的图片格式');
                return;
            }
            let formData = new FormData();
            formData.append('modelImage', file);
            upload(formData).then((res) => {
                if (res.code === '200') {
                    this.basicPropertyMap.icon = res.data.url;
                    this.$forceUpdate()
                }
            })
        },
        getImage() {
            // const _this = this
            // Swal.fire({
            //     title: '生成图标',
            //     text: `根据当前截图生成图标`,
            //     type: 'warning',
            //     showCancelButton: true,
            //     confirmButtonClass: 'md-button md-success btn-fill',
            //     cancelButtonClass: 'md-button md-danger btn-fill',
            //     confirmButtonText: '确 定',
            //     cancelButtonText: '取 消',
            //     buttonsStyling: false
            // }).then((result) => {
            //     if (result.value) {
            //         let base64 = _this.topNode.$refs.ThreeModel.getImage()
            //         _this.basicPropertyMap.icon = base64
            //         _this.$forceUpdate()
            //     }
            // })
            // this.$nextTick(() => {
            //     document.getElementById('mainCardContent').appendChild(document.querySelector('.swal2-container'))
            // })
        },
        base64toFile(dataurl, filename = 'file') {
            let arr = dataurl.split(',')

            let mime = arr[0].match(/:(.*?);/)[1]

            let suffix = mime.split('/')[1]

            let bstr = Buffer.from(arr[1], 'base64')

            let n = bstr.length

            let u8arr = new Uint8Array(n)

            while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }
            return new File([u8arr], `${filename}.${suffix}`, {
                type: mime
            })
        }
    }
};
</script>
<style>
.pictureImg input[type=file] {
    cursor: pointer;
    display: block;
    height: 100%;
    left: 0;
    opacity: 0 !important;
    position: absolute;
    top: 0;
    width: 100%;
}
</style>